import axios from "axios";

export interface HeaderAuthAxios {
  userId?: string | null;
  token?: string | null;
  accountId?: string | null;
}

export default function setAuthHeaderAxios(
  headersAuth: HeaderAuthAxios | null
) {

  if (!headersAuth) {
    delete axios.defaults.headers.common["userID"];
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["accountID"];
    return;
  }

  if (headersAuth?.userId) {
    axios.defaults.headers.common["userID"] = headersAuth.userId;
  }

  if (headersAuth?.accountId) {
    axios.defaults.headers.common["accountID"] = headersAuth.accountId;
  }

  if (headersAuth?.token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${headersAuth.token}`;
  }
}
